export default {
    MP: 'Menor Preço',
    MD: 'Maior Desconto',
    MO: 'Maior Oferta',
    MRO: 'Maior Retorno Econômico',
    MTC: 'Melhor Técnica',
    TP: 'Técnica e Preço',
    ML: 'Maior Lance',
    CA: 'Conteúdo Artístico',
    MT: 'Menor Taxa Administrativa',
    MLO: 'Maior Lance ou Oferta',
    MCA: 'Melhor Conteúdo Artístico',
    MCTP: 'Melhor Combinação de Técnica e Preço',
    MOP: 'Maior Oferta de Preço',
    MDBA: 'Melhor Destinação de Bens Alienados',
    NA: 'Não se Aplica'
}
